import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { OtpRequest } from '../client-sdk/api';

export const useResendOTPApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createResendOTP = useCallback(
    async (data: OtpRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.resendOtp(data);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    createResendOTP,

    loading,
    error,
  };
};
